<template>
  <div class="form-certification">
    <c-legend />
    <edit-table
      :option="option"
      :data="formatData"
      :form.sync="form"
      :loading="loading"
      @submit-add="handleSubmit"
      @submit-edit="handleUpdate"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    >
      <template
        slot="row-details"
        slot-scope="{row}"
      >
        <div style="display:flex;justify-content: space-between;margin-right:200px;">
          <span
            v-for="(item, i) in option.columns"
            :key="i"
          >
            {{ updateAuditData[row.item.id][(item.dictField ? item.dictField : item.field)] }}
          </span>
        </div>
      </template>
    </edit-table>
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { education, infoAudit } from '@/api/staff/index';
import { deepClone } from '@/util/util'
import CLegend from './components/legend.vue'
import getColumn from './option/infoEdu'

export default {
  components: {
    EditTable,
    CLegend,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    staffId: {
      type: String,
      default: '',
    },
    auditData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      redata: [],
      reauditData: [],
      loading: false,
      // 需要number转string的类型
      hasToStringTypes: ['select'],
      // data: [
      //   {
      //     projectId: 'wangsan',
      //     status: '1',
      //     nationality: '2',
      //     startDate: '2021-1-2 12:13:00',
      //     endDate: '2021-1-2 12:13:00',
      //     remark: 'wuhan',
      //   },
      // ],
      form: {
        status: '1',
      },
      updateAuditData: {},
    }
  },
  computed: {
    option() {
      const option = {
        drawer: true,
        menu: !this.disabled,
        addBtn: !this.disabled,
        columns: getColumn(this.form, this.staffId),
      }
      return option
    },
    formatData() {
      const res = []
      const redata = deepClone(this.redata)
      const kkk = '_rowVariant';
      if (Array.isArray(this.reauditData)) {
        this.reauditData.forEach(e => {
          const newData = (e.newDataName || e.newData) || (e.oldDataName || e.oldData)
          if (newData) {
            const item = JSON.parse(newData)
            item.option_viewBtn = true
            item.option_editBtn = true
            item.option_delBtn = true
            if (e.action === 'update') {
              const find = redata.find(o => o.id === item.id) || {}
              find[kkk] = 'warning'
              find.option_viewBtn = true
              find.option_editBtn = true
              find.option_delBtn = true
              find.option_detailBtn = true
              this.updateAuditData[item.id] = item
              return
            }
            if (e.action === 'save') {
              item[kkk] = 'success'
            } else if (e.action === 'remove') {
              const find = redata.find(o => o.id === item.id) || {}
              find[kkk] = 'danger'
              find.option_viewBtn = true
              find.option_editBtn = true
              find.option_delBtn = true
              return
            }
            redata.push(item)
          }
        })
      }
      redata.forEach(row => {
        const temp = row
        this.option.columns.forEach(item => {
          const type = item.formOption ? item.formOption.type : 'none'
          if (this.hasToStringTypes.indexOf(type) !== -1) {
            temp[item.field] = row[item.field] ? row[item.field].toString() : ''
          }
        });
        res.push(temp)
      })

      return res
    },
  },
  watch: {
    currentTab(e) {
      if (e === 1) {
        this.onLoad()
      }
    },
  },
  mounted() {
    this.redata = this.data
    this.reauditData = this.auditData
  },
  methods: {
    async onLoad() {
      this.loading = true
      const res2 = await infoAudit.getList(1, -1, { staffId: this.staffId, status: 1, module: 'infoEdu' })
      this.reauditData = res2.data.data.records
      const res = await education.getList(1, -1, { staffId: this.staffId })
      this.redata = res.data.data.records
      this.loading = false
    },
    // 国际化
    i18n(param) {
      return this.$t(`_staff.labelEdu.${param}`)
    },
    handleSubmit(done, row = {}) {
      const params = row
      params.staffId = this.staffId
      education.add(params).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    handleUpdate(done, row = {}) {
      const params = row

      Object.keys(params).forEach(key => {
        const element = params[key];
        if (!element) {
          delete params[key]
        }
      })
      education.update(params).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    handleRowDel(done, row) {
      education.remove(row.id).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    refreshChange() {
      this.onLoad()
    },
  },
}
</script>
<style lang="scss">
.form-certification{
  &-top{
    text-align: right;
  }
  .table-td{
    text-align: center;
    line-height: 50px;
    &-sm{
      width: 200px;
    }
  }
}
</style>
